export { default } from "./InfiniteCollectionItem";
